import { create } from "zustand";

export type GapAnalysisStep = 0 | 1 | 2 | 3;

interface GapAnalysisGenerationState {
  conceptId: string | null;
  jobId: string | null;
  isPending: boolean;
  isCompleted: boolean;
  error: string | null;
  step: GapAnalysisStep;
  stepLabel: string;
  totalSteps: number;
  startedAt: number | null;
  cancelController: AbortController | null;

  start: (conceptId: string, jobId: string) => void;
  setStep: (step: GapAnalysisStep, label: string) => void;
  setCancelController: (controller: AbortController | null) => void;
  fail: (error: string) => void;
  finish: () => void;
  reset: () => void;
}

const initialState = {
  conceptId: null,
  jobId: null,
  isPending: false,
  isCompleted: false,
  error: null,
  step: 0 as GapAnalysisStep,
  stepLabel: "",
  totalSteps: 3,
  startedAt: null,
  cancelController: null,
};

export const useGapAnalysisGenerationStore = create<GapAnalysisGenerationState>(
  (set) => ({
    ...initialState,

    start: (conceptId, jobId) =>
      set({
        ...initialState,
        conceptId,
        jobId,
        isPending: true,
        startedAt: Date.now(),
        stepLabel: "Preparing…",
      }),

    setStep: (step, label) => set({ step, stepLabel: label }),

    setCancelController: (cancelController) => set({ cancelController }),

    fail: (error) =>
      set({ isPending: false, error, step: 0, stepLabel: "" }),

    finish: () =>
      set({
        isPending: false,
        isCompleted: true,
        step: 3,
        stepLabel: "Complete",
      }),

    reset: () => set({ ...initialState }),
  }),
);
